import { Component, AfterViewInit, Renderer2, Inject, OnInit } from '@angular/core';
import { AuthenticationService,EmployeesService,SurveyService, ProfileService, AlertService,CompanyService } from '../../_services/index';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormsModule } from '@angular/forms';
import * as Prism from 'prismjs';
import {Router, ActivatedRoute} from "@angular/router"
import { DOCUMENT } from '@angular/platform-browser';
import { ThemeService } from 'ng2-charts';
import * as moment from 'moment'
@Component({
    selector: 'app-company',
    templateUrl: './surveyEmployee.component.html',
    styleUrls: ['./surveyEmployee.component.scss']
  })
  export class SurveyEmployeeComponent implements OnInit {
    public authorized:any;
    public lastDiseases:any;
    public user:any;
    public roles:any;
    public employee:any;
    public diseases:any;
    public survey:any='';
    public idDiseases:any=[];
    public a:any;
    BirthDate:Date;
    constructor(
        public as: AuthenticationService,
        public alertService:AlertService,
        public employeesService:EmployeesService,
        public surveyService:SurveyService,
        public profileService: ProfileService,
        private route: ActivatedRoute,
        private router: Router,
        @Inject(DOCUMENT) private _document,
    ){
        this.authorized = this.as.checkAuthentication();
        if(!this.authorized.authorized){
            this.router.navigate(['/login'])
        }
    }

    ngOnInit() {
        this.profileService.cast.subscribe(response => {
            this.user = response;
        }, error => {
        })
        this.employeesService.getDiseaseList().subscribe(response => {
            this.diseases = response;
        }, error => {
        })
        if (this.route.snapshot.params && this.route.snapshot.params.id) {
            this.employeesService.getEmployeeOne(this.route.snapshot.params.id).subscribe(response => {
                this.employee = response;
                for (let i = 0; i < this.employee.Diseases.length; i++) {
                    this.idDiseases.push(this.employee.Diseases[i].id)
                }
                if(this.employee.surveys.length > 0){
                    this.survey=this.employee.surveys[this.employee.surveys.length-1];
                }
                if(!response){
                    this.alert({reason:'No se ha podido cargar el empleado.', type:"danger"});
                    this.router.navigate(['/empleados']);
                }
            }, error => {
                this.alert({reason:'No se ha podido cargar el empleado.', type:"danger"});
                this.router.navigate(['/empleados']);
            })
            /*this.surveyService.getSurveyEmployeeOne(this.route.snapshot.params.id).subscribe(response => {
                this.survey = response;
                for (let i = 0; i < this.survey.user.Diseases.length; i++) {
                    this.idDiseases.push(this.survey.user.Diseases[i].id)
                }
            }, error => {
            })*/
        }else{
            this.alert({reason:'No se ha podido cargar la encuesta.', type:"danger"});
            this.router.navigate(['/encuestas']);
        }
        
    }
    alert(data){
        this.alertService.updateAlert(data).subscribe(()=>{
            setTimeout(() => {
            this.alertService.deleteAlert().subscribe();
            }, 8000);
        })
    }
    
}


